class AnnouncementTimer extends HTMLElement {
  connectedCallback() {
    const specificDate = this.getAttribute('data-end-date');
    const endDate = specificDate ? new Date(specificDate.replace(' ', 'T')) : this.getMonthEnd(new Date());
    const hideOnExpire = this.getAttribute('data-hide-on-expire') === 'true';

    if (isNaN(endDate.getTime())) return;

    this.dayEl = this.querySelector('[data-day]');
    this.hourEl = this.querySelector('[data-hour]');
    this.minuteEl = this.querySelector('[data-minute]');
    this.secondEl = this.querySelector('[data-second]');

    const update = () => {
      const distance = endDate.getTime() - Date.now();

      if (distance <= 0) {
        this.render(0, 0, 0, 0);
        clearInterval(this.interval);
        if (hideOnExpire) {
          this.closest('.announcement-timer-bar')?.remove();
        }
        return;
      }

      const days = this.dayEl ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
      const hourSpan = this.dayEl ? distance % (1000 * 60 * 60 * 24) : distance;
      const hours = Math.floor(hourSpan / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.render(days, hours, minutes, seconds);
    };

    update();
    this.interval = setInterval(update, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  render(days, hours, minutes, seconds) {
    const pad = (value) => String(value).padStart(2, '0');
    if (this.dayEl) this.dayEl.textContent = pad(days);
    if (this.hourEl) this.hourEl.textContent = pad(hours);
    if (this.minuteEl) this.minuteEl.textContent = pad(minutes);
    if (this.secondEl) this.secondEl.textContent = pad(seconds);
  }

  getMonthEnd(date) {
    const dateCopy = new Date(date.getTime());
    dateCopy.setMonth(dateCopy.getMonth() + 1, 1);
    dateCopy.setDate(dateCopy.getDate() - 1);
    dateCopy.setHours(23, 59, 59, 999);
    return dateCopy;
  }
}

customElements.define('announcement-timer', AnnouncementTimer);
